import { Button, IconButton, Box, TableRow } from "@mui/material";
import { Helmet } from "react-helmet";
import { smallButton } from "../../../components/Button";
import Navbar from "../../../components/navbar";
import StickyTable from "../../../components/table";
import { Cell } from "../../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import styled from "@emotion/styled";
import { DeleteModal } from "../../../components/appbar/modal";
import { useModal } from "../../../components/modal";
import AddModal from "./modal";
import MainFrame from "../../../components/mainFrame";
import OrgansMenuItems from "../components/menuitems";
import {
  useGetMembersQuery,
  useRemoveMemberMutation,
  useRemovePendingMemberMutation,
} from "../../../app/services/organ.api";
import TextContainer from "../../../components/Texts/TextContainer";
import { useParams } from "react-router-dom";
import getImageLink from "../../../utils/getImageLink";
import { useState } from "react";
import { PaginationQuery } from "../../../types/query";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
  overflowY: "auto",
});
function OrganMembers() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<PaginationQuery>({
    page: 0,
    size: 10,
  });
  const params = useParams() as { organ: string };
  const { data, isLoading, isFetching } = useGetMembersQuery({
    query,
    organId: params.organ,
  });
  const [removeMember] = useRemoveMemberMutation();
  const [removePending] = useRemovePendingMemberMutation();
  function handleOpenModal(type: string, id?: string) {
    if (type === "delete-pending" && id) {
      setContent({
        title: "حذف شماره در انتظار",
        body: (
          <DeleteModal
            handleDelete={() => {
              removePending({ organId: params.organ, pendingId: id })
                .unwrap()
                .then(() => setShow(false))
                .catch(() => {});
            }}
          />
        ),
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف عضو",
        body: (
          <DeleteModal
            handleDelete={() => {
              removeMember({ organId: params.organ, memberId: id })
                .unwrap()
                .then(() => setShow(false))
                .catch(() => {});
            }}
          />
        ),
      });
    }
    if (type === "add") {
      setContent({
        title: "افزودن عضو",
        body: <AddModal organId={params.organ} />,
      });
    }
    setShow(true);
  }

  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> اعضای سازمان | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="اعضای سازمان">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن عضو
        </Button>
      </Navbar>
      <StickyTable
        headers={[{ name: "تصویر" }, { name: "نام" }, { name: "شماره تماس" }]}
        length={data?.length ?? 0}
        operations={true}
        isLoading={isLoading || isFetching}
        onPageQueryChange={(q) => setQuery((prev) => ({ ...prev, ...q }))}
      >
        {data?.members?.ids?.map((id, indx) => {
          const member = data?.members.entities[id];
          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={id}
              sx={{ cursor: "pointer" }}
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>
                {member.profile ? (
                  <img
                    width={"10%"}
                    height={"10%"}
                    alt="profile"
                    src={getImageLink(member.profile)}
                  />
                ) : (
                  "not set"
                )}
              </Cell>
              <Cell>{member.userName}</Cell>
              <Cell>{member.phone}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("delete", id)}>
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
      {!!data?.pending?.length && (
        <Box sx={{ marginTop: "1rem" }}>
          <TextContainer color="divider" fontWeight="bold" margin="0 0 .5rem 0">
            شماره‌های در انتظار ثبت‌نام ({data.pending.length.toLocaleString("fa-IR")})
          </TextContainer>
          <TextContainer color="divider" fontSize=".8rem" margin="0 0 .5rem 0">
            این شماره‌ها هنوز در سایت ثبت‌نام نکرده‌اند؛ پس از ثبت‌نام با همین شماره، خودکار عضو سازمان می‌شوند.
          </TextContainer>
          <StickyTable
            headers={[{ name: "شماره تماس" }, { name: "تاریخ افزودن" }]}
            length={data.pending.length}
            operations={true}
            isLoading={isLoading || isFetching}
            onPageQueryChange={() => {}}
          >
            {data.pending.map((item, indx) => (
              <TableRow hover tabIndex={-1} key={item._id}>
                <Cell
                  sx={{
                    "&.MuiTableCell-root": {
                      color: "divider",
                      fontSize: ".8rem",
                    },
                  }}
                >
                  {indx + 1}
                </Cell>
                <Cell>{item.phone}</Cell>
                <Cell>
                  {item.createdAt
                    ? new Date(item.createdAt).toLocaleDateString("fa-IR")
                    : "-"}
                </Cell>
                <Cell
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    onClick={() => handleOpenModal("delete-pending", item._id)}
                  >
                    <DeleteIcon sx={{ color: "divider" }} />
                  </IconButton>
                </Cell>
              </TableRow>
            ))}
          </StickyTable>
        </Box>
      )}
    </Container>
  );
}

export default MainFrame(OrganMembers, <OrgansMenuItems />);
